module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/umbrella-stand/bronze-texture.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/umbrella-stand/bronze-texture.jpg
// module id = 648
// module chunks = 0